var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 440,
    viewBox: "0 0 680 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605.156 0V58.8748L676.004 58.8748V60.8748L605.156 60.8748V165.319H679.922L679.922 167.319H605.156V271.764H676.004V273.764H605.156V378.209H676.004V380.209H605.156V439.083H603.156V380.209H498.711V439.083H496.711V380.209H392.266V439.083H390.266V380.209L285.824 380.209V439.083H283.824V380.209H180.043V439.083H178.043V380.209H73.5977V439.083H71.5977V380.209H0.0820312V378.209H71.5977V273.765H0.0820312V271.765H71.5977V167.319H4V165.319H71.5977V60.8749L0.0820312 60.8749V58.8749L71.5977 58.8749V0H73.5977V58.8749L178.043 58.8749V0H180.043V58.8749L283.824 58.8749V0H285.824V58.8749H390.266V0H392.266V58.8749L496.711 58.8748V0H498.711V58.8748L603.156 58.8748V0H605.156ZM73.5977 378.209V273.765H178.043V378.209H73.5977ZM180.043 378.209V273.765H283.824V378.209H180.043ZM285.824 378.209V273.765L390.266 273.764V378.209L285.824 378.209ZM392.266 378.209V273.764H496.711V378.209H392.266ZM498.711 378.209V273.764H603.156V378.209H498.711ZM603.156 271.764V167.319H498.711V271.764H603.156ZM603.156 165.319H498.711V60.8748L603.156 60.8748V165.319ZM496.711 271.764V167.319H392.266V271.764H496.711ZM496.711 165.319H392.266V60.8749L496.711 60.8748V165.319ZM390.266 271.764V167.319L285.824 167.319V271.765L390.266 271.764ZM390.266 165.319L285.824 165.319V60.8749H390.266V165.319ZM283.824 271.765V167.319H180.043V271.765H283.824ZM283.824 165.319H180.043V60.8749L283.824 60.8749V165.319ZM178.043 271.765V167.319H73.5977V271.765H178.043ZM178.043 165.319H73.5977V60.8749L178.043 60.8749V165.319Z",
    fill: "url(#paint0_linear_3208_5377)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3208_5377",
    x1: 739.871,
    y1: -74.5111,
    x2: -67.1113,
    y2: 460.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374C72",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2435",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.887297b901ba15badb251e915d8f72bd.svg";
export { ForwardRef as ReactComponent };